const state = {
    all: new Array(),
    allUnfiltered: new Array()
};
const getters = {
    properties(state) {
        return state.all;
    },
    unfilteredProperties(state) {
        return state.allUnfiltered;
    },
};
const actions = {
    initializeClient({ commit }, clientId) {
        window.App.$axios
            .get(`/api/setting/api/v1.0/companyid/${clientId}/property/dropdown?api_user=${window.eInsightUserEmail}`)
            .then((response) => {
            const properties = new Array();
            const unfilteredProperties = new Array();
            response.data.data.forEach((value) => {
                unfilteredProperties.push({ text: value.name, code: value.propertyCode });
                if (value.hasAccess) {
                    properties.push({ text: value.name, code: value.propertyCode });
                }
            });
            commit('setUnfilteredProperties', { properties: unfilteredProperties });
            commit('setProperties', { properties });
        })
            .catch((xhr) => {
            // TODO: Handle failed API call
            console.log('Property Store => Failed to load Properties', xhr);
        }).then(() => {
            // setting to True even if failed
            window.InitializationWatcher.propertiesLoaded = true;
        });
    }
    // storeClientProperties({ commit }, propertiesSet: any) {
    //    console.log(`store/property => storeClientProperties`, propertiesSet);
    //    state.all = propertiesSet.properties;
    //    state.allUnfiltered = propertiesSet.properties;
    // },
};
const mutations = {
    setProperties(state, data) {
        state.all = data.properties;
    },
    setUnfilteredProperties(state, data) {
        state.allUnfiltered = data.properties;
    }
};
export const property = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
//# sourceMappingURL=index.js.map